module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/cowboys.1174406.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/cowboys.png
// module id = xuJu
// module chunks = 0